import { useParams } from 'react-router';
import { useFarm } from '../../queries/FarmQueries';
import { useStates } from '../../queries/CommonQueries';
import AppLayout from '../../components/AppLayout';
import AddUpdateFarmForm from '../../components/AddUpdateFarmForm';
import ShowPending from '../../components/ShowPending';
import { useUserDetails } from '../../helpers/UserContext';
import type { Farm } from '../../models/Farm';

export default function UpdateFarm() {
  const params = useParams();
  const farmId = params?.id ? +params.id : 0;
  const [userDetails] = useUserDetails();

  const { data: farm, isPending } = useFarm(farmId);
  const { data: states, isPending: statesPending } = useStates();

  return (
    <AppLayout>
      <main>
        <h3 className='text-center text-2xl dark:text-gray-300'>
          {farmId > 0 ? 'Update' : 'Add'} Farm
        </h3>
        {(farmId > 0 && isPending) || statesPending ? (
          <ShowPending isPending={isPending} />
        ) : (
          <AddUpdateFarmForm
            states={states}
            farm={
              farm
                ? farm
                : ({
                    applicationUserId: userDetails?.userId ?? '',
                    farmId: 0,
                    active: true,
                  } as Farm)
            }
          />
        )}
      </main>
    </AppLayout>
  );
}
